<script setup lang="ts">
    import { Avatar, AvatarImage, AvatarFallback } from '@/components/ui/avatar';
    import { useInitials } from '@/composables/useInitials';
    import type { User } from '@/types';
    import type { HTMLAttributes } from 'vue';
    import { cn } from '@/lib/utils';

    const { getInitials } = useInitials();

    const props = defineProps<{
        user?: User;
        class?: HTMLAttributes['class'];
    }>();
</script>

<template>
    <Avatar :class="cn('border-foreground size-6', props.class)">
        <AvatarImage
            v-if="user && user.avatar"
            :src="user.avatar"
            :alt="user.name"
        />
        <AvatarFallback> {{ getInitials(user?.name) }}</AvatarFallback>
    </Avatar>
</template>
